import { CardBaseHeader, Label } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { riskMock } from '../../../api';
import { Doughnut } from '../graph';
import { RiskCard } from './Styles';

export const Risk = () => {
  const { t } = useTranslation();

  const riskData = riskMock;
  return (
    <RiskCard>
      <CardBaseHeader noBorder small>
        <Label fontSize="14" semibold>
          {t('Risky type')}
        </Label>
      </CardBaseHeader>
      <Doughnut
        data={riskData}
        style={{
          height: '100%',
          width: '100%',
        }}
      />
    </RiskCard>
  );
};
